import React from 'react';

import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import Subscribe from 'bz-utilities/modules/plugins/subscribe';

import type GroupsStore from 'tm3-core/cache/stores/groups-store';
import EVariant from 'tm3-core/events/enums/variant';
import GroupUpdateEvent from 'tm3-core/events/group';

interface IProps {
  groupsCache?: GroupsStore;
}

@inject('groupsCache')
@observer
class GroupSubscriber extends React.Component<IProps> {
  @bind
  private onGroupUpdate(event: GroupUpdateEvent): void {
    switch (event.variant) {
      case EVariant.created:
        return this.onCreated(event);
      case EVariant.updated:
        return this.onUpdated(event);
      case EVariant.deleted:
        return this.onDeleted(event);
      default:
        break;
    }
  }

  @action.bound
  private onCreated(event: GroupUpdateEvent): void {
    const { group } = event;
    const { groupsCache } = this.props;

    groupsCache!.onUpdate(group!.id, group!);
  }

  @action.bound
  private onUpdated(event: GroupUpdateEvent): void {
    const { group } = event;
    const { groupsCache } = this.props;
    groupsCache!.onUpdate(group!.id, group!);
  }

  @action.bound
  private onDeleted(event: GroupUpdateEvent): void {
    const { group } = event;
    const { groupsCache } = this.props;

    groupsCache!.onDelete(group!.id);
  }

  render() {
    return (
      <Subscribe<GroupUpdateEvent> type={GroupUpdateEvent} handler={this.onGroupUpdate}>
        {this.props.children}
      </Subscribe>
    );
  }
}

export default GroupSubscriber;
